import React, { useEffect, useRef } from 'react';
import { Loader, Text } from '@wix/design-system';
import { useCreateSitelessMetasite } from 'api';
import { useSessionId } from 'hooks/useSessionId';
import { redirectToPremium } from 'utils/premium';
import { Background } from 'components/App/Background';
import styles from './MinimalSetupStep.scss';

export function MinimalSetupStep() {
  const { mutate, isError } = useCreateSitelessMetasite();
  const sessionId = useSessionId();
  const didMutateRef = useRef(false);

  useEffect(() => {
    if (didMutateRef.current) {
      return;
    }
    didMutateRef.current = true;

    mutate(undefined, {
      onSuccess: (metaSiteId) => {
        redirectToPremium({ metaSiteId, sessionId });
      },
    });
  }, [mutate, sessionId]);

  return (
    <div className={styles.wrapper}>
      <Background />
      {isError ? (
        <Text size="medium" secondary>
          Something went wrong. Please try refreshing the page.
        </Text>
      ) : (
        <Loader size="large" />
      )}
    </div>
  );
}
